// DS: MO 0.11
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import cn from 'classnames';
import { useSelectByTheme } from '@wix/da-react-context/pkg/ThemeContext';
import isEmpty from 'lodash/isEmpty';
import ImageOnlyLayout from './_partials/ImageOnlyLayout';
import SmallTextLayout from './_partials/SmallTextLayout/SmallTextLayout';
import LargeTextLayout from './_partials/LargeTextLayout/LargeTextLayout';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading/Heading';
import ClockIcon from '../Icons/24x24/Clock';
import Countdown from '../Time/Countdown';
import SolidButton from '../Buttons/SolidButton/SolidButton';
import s from './DealerCard.scss';
const DealerCard = (props)=>{
    const { className, title, description, onCtaClick, backgroundImageDark, backgroundImageLight, backgroundImageGreen, fontSize, titleColor, bodyColor, cta, countdownTimer, backgroundColor, align } = props;
    let backgroundImage = useSelectByTheme({
        dark: backgroundImageDark || '',
        light: backgroundImageLight || '',
        green: backgroundImageGreen || ''
    });
    // CMS can return off stuff and empty strings
    if (!backgroundImage || backgroundImage === '') {
        backgroundImage = [
            backgroundImageDark,
            backgroundImageLight,
            backgroundImageGreen
        ].filter((f)=>!isEmpty(f)).pop();
    }
    let content = null;
    const isLarge = fontSize === 'large';
    const Layout = isLarge ? LargeTextLayout : SmallTextLayout;
    const customBg = !isEmpty(backgroundColor) ? backgroundColor : undefined;
    if (isEmpty(title) && isEmpty(description) && backgroundImage) {
        // Background-only
        content = /*#__PURE__*/ React.createElement(ImageOnlyLayout, {
            backgroundImage: backgroundImage
        });
    } else {
        // Small and large layouts
        content = /*#__PURE__*/ React.createElement(Layout, _object_spread_props(_object_spread({}, props), {
            backgroundImage: backgroundImage
        }), /*#__PURE__*/ React.createElement("div", {
            className: cn(s['content'], (customBg || isLarge) && s['no-bg'], align && s[`align-${align}`])
        }, !isEmpty(title) && /*#__PURE__*/ React.createElement(Heading, {
            className: cn(s['heading'], isLarge && s['heading-large']),
            style: {
                color: titleColor
            }
        }, title), !isEmpty(description) && /*#__PURE__*/ React.createElement("p", {
            className: s['text'],
            style: {
                color: bodyColor
            }
        }, description), !isEmpty(cta === null || cta === void 0 ? void 0 : cta.url) && !isEmpty(cta === null || cta === void 0 ? void 0 : cta.label) && /*#__PURE__*/ React.createElement("div", {
            className: s['cta-wrap']
        }, /*#__PURE__*/ React.createElement(SolidButton, {
            className: s['cta'],
            size: "medium",
            variant: "approval-green",
            href: cta === null || cta === void 0 ? void 0 : cta.url,
            target: "_blank",
            rel: "noopener",
            style: {
                color: cta === null || cta === void 0 ? void 0 : cta.color,
                backgroundColor: cta === null || cta === void 0 ? void 0 : cta.backgroundColor
            },
            onClick: ()=>onCtaClick && onCtaClick(cta === null || cta === void 0 ? void 0 : cta.url)
        }, cta === null || cta === void 0 ? void 0 : cta.label)), countdownTimer && parseInt(countdownTimer) > 0 && /*#__PURE__*/ React.createElement("div", {
            className: s['countdown'],
            style: {
                color: bodyColor
            }
        }, /*#__PURE__*/ React.createElement(ClockIcon, {
            className: s['countdown-icon'],
            disableDefaultColors: true
        }), /*#__PURE__*/ React.createElement(Countdown, {
            countToDate: `${countdownTimer}`,
            minutesOnly: true,
            renderTimer: (d, h, m)=>`${d}d ${h}h ${m}m`
        }))));
    }
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className),
        onClick: ()=>{
            onCtaClick && onCtaClick(cta === null || cta === void 0 ? void 0 : cta.url);
            window.open(cta === null || cta === void 0 ? void 0 : cta.url, '_blank');
        }
    }, content);
};
DealerCard.displayName = 'DealerCard';
export default DealerCard;
